import styled from 'styled-components';

const clsPrefix = 'ui-table';
const tableClsPrefix = `${clsPrefix}-table`;

export const tableClasses = {
  component: clsPrefix,
  table: tableClsPrefix,
  tableContainer: `${tableClsPrefix}-container`,
  tableContent: `${tableClsPrefix}-content`,
  tableRow: `${tableClsPrefix}-row`,
  tableCol: `${tableClsPrefix}-column`,
  tableEmpty: `${tableClsPrefix}-empty`,
  tableLoader: `${tableClsPrefix}-loader`,
  pagination: `${clsPrefix}-pagination`,
} as const;

export const TableWrapperSC = styled.div`
  width: 100%;

  .table-container {
    background-color: white;
    border-radius: 10px;
  }

  .${tableClasses.pagination} {
    display: flex;
    justify-content: flex-end;
    padding-top: 16px;
  }

  .ui-table-action {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;

    width: 32px;
    height: 32px;

    border: none;
    border-radius: 32px;
    cursor: pointer;
    outline: none;

    background-color: ${({ theme }) => theme.color.surface.secondary};

    &:hover {
      background-color: ${({ theme }) =>
        theme.createOverlayColor(theme.color.surface.secondary, 'hover')};
    }
  }

  .${tableClasses.tableContainer} {
    position: relative;
    border-radius: 12px;
    box-shadow: ${({ theme }) => theme.shadows.low};
    overflow: hidden;
    overflow-x: auto;

    .${tableClasses.tableLoader} {
      position: absolute;

      display: flex;
      align-items: center;
      justify-content: center;

      z-index: 1;
      inset: 0;

      background: rgba(255, 255, 255, 0.6);
    }
  }
`;

export const TableSC = styled.table`
  background: ${({ theme }) => theme.color.surface.baseline};
  width: 100%;

  thead {
    border: 0;

    th {
      padding: 16px 0;
      padding-left: 24px;
      transition: all 0.2s;

      background: ${({ theme }) => theme.color.surface.background};
      user-select: none;

      &:first-child {
        border-top-left-radius: 12px;
      }

      &:last-child {
        border-top-right-radius: 12px;

        padding-right: 24px;
      }

      td {
        transition: all 0.2s;
        text-align: left;
        color: ${({ theme }) => theme.color.tint.primary};
        ${({ theme }) => theme.mappedTypography.h6.strong};
      }
    }
  }

  tbody {
    tr {
      transition: all 0.2s;

      td {
        transition: all 0.2s;
        padding: 16px 0;
        padding-left: 24px;
        background: ${({ theme }) => theme.color.surface.baseline};

        ${({ theme }) => theme.mappedTypography.body2.strong};

        &:first-child {
          text-align: left;
        }

        &:last-child {
          padding-right: 24px;
        }

        &.ui-table-empty-cell {
          padding: 0;
        }
      }

      &:not(:last-child) {
        td {
          border-bottom: 1px solid ${({ theme }) => theme.color.border.emphasis};
        }
      }

      &:last-child {
        td:first-child {
          border-bottom-left-radius: 12px;
        }
        td:last-child {
          border-bottom-right-radius: 12px;
        }
      }

      &:hover td {
        background: ${({ theme }) =>
          theme.createOverlayColor(theme.color.surface.baseline, 'hover')};
      }
    }
  }

  .${tableClasses.tableContent} {
    p {
      margin: 0;
    }
  }

  .${tableClasses.tableEmpty} {
    padding: 40px;
  }
`;

export const ActionsSC = styled.div`
  min-width: 100%;
  display: flex;
`;
